<div class="lock-container">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="83"
    height="114"
    viewBox="0 0 83 114"
    fill="none"
    >
    <path
      d="M41.4999 0C23.1173 0 8.16136 14.9553 8.16136 33.3386V52.3791C8.16136 52.5954 7.89435 52.96 7.6846 53.0297C5.88177 53.6309 4.41761 54.1519 3.07731 54.6686C1.47896 55.2848 0.273438 57.0561 0.273438 58.789V102.539C0.273438 104.26 1.47117 106.033 3.05939 106.662C15.3478 111.532 28.281 114 41.4997 114C54.7185 114 67.6517 111.531 79.9407 106.661C81.5283 106.032 82.7254 104.26 82.7254 102.539V58.789C82.7254 57.0561 81.5201 55.2848 79.921 54.668C78.5801 54.1513 77.1161 53.6304 75.3147 53.0292C75.1055 52.9594 74.8385 52.5947 74.8385 52.3783V33.338C74.8375 14.9553 59.8826 0 41.4999 0ZM32.4193 72.1137C32.4193 67.0951 36.4848 63.0339 41.4993 63.0339C46.5135 63.0339 50.579 67.0947 50.579 72.1137C50.579 75.4391 48.7037 78.2233 46.0391 79.8016V94.8134C46.0391 97.323 44.0085 99.3533 41.4991 99.3533C38.9895 99.3533 36.9592 97.323 36.9592 94.8134V79.8016C34.2948 78.2233 32.4193 75.4391 32.4193 72.1137ZM63.3749 33.338V49.7664C56.1867 48.2217 48.8552 47.4421 41.5028 47.4405C34.1486 47.4426 26.8151 48.2217 19.6246 49.7647V33.338C19.6246 21.2759 29.4375 11.4632 41.4993 11.4632C53.561 11.463 63.3749 21.2759 63.3749 33.338Z"
      fill="#033A09"
      />
    </svg>
    <h1 data-translation-key="horse_info_access_locked">
      {{ 'horse_info.access_locked' | translate }}
    </h1>
    @if (lockType === 'accepted_buyer') {
      <p>
        <span data-translation-key="horse_info_accepted_buyer_lock_type_msg">
          {{ 'horse_info.accepted_buyer_lock_type_msg' | translate }}</span
          >
          <span data-translation-key="horse_info_view_the">{{ 'horse_info.view_the' | translate }}</span>
          {{ category }}
          <span data-translation-key="horse_info_accepted_buyer_lock_type_msg">
            {{ 'horse_info.accepted_buyer_lock_type_msg' | translate }}</span
            >
          </p>
        }
        @if (lockType === 'login_required') {
          <p>
            <span data-translation-key="horse_info_login_lock_type_msg">{{ 'horse_info.login_lock_type_msg' | translate }}</span>
            {{ category }}.
            <span data-translation-key="horse_info_please_login">{{ 'horse_info.please_login' | translate }}</span>
          </p>
        }

        <app-request-to-bid-button
          class="w-100"
          [loggedIn]="loggedIn"
          [auctionSettings]="auctionSettings"
          [horseDetails]="horseDetails"
          [aucType]="aucType"
          [lockType]="lockType"
        ></app-request-to-bid-button>
      </div>
